import { CheckboxField } from "components/RenderInput"
import React, { forwardRef } from "react"
import { Card, Col, Row } from "reactstrap"
import { Field } from "redux-form"
import { customTextField, disableSaveButton } from "./utils"
import { SaveButton } from "components/Buttons"

const ContactCard = forwardRef(
  (
    {
      removeContactHandler,
      updateContactHandler,
      style,
      attributes,
      listeners,
      contact,
      ...props
    },
    ref
  ) => {
    return (
      <div ref={ref} style={style}>
        <Card
          className="my-3"
          style={{ backgroundColor: "#e7e9ec", padding: "10px" }}
        >
          <Row>
            <Col
              xs="auto"
              style={{ paddingRight: "0px" }}
              {...attributes}
              {...listeners}
            >
              <i
                className="bx bx-sm bx-menu"
                style={{
                  cursor: "pointer",
                }}
              />
            </Col>
            <Col>
              <p style={{ color: "#485ec4", fontSize: "14px" }}>
                {props?.contactValues?.name} ({props?.contactValues?.email})
              </p>
            </Col>
            <Col xs="auto">
              <i
                className="bx bx-sm bx-x"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  removeContactHandler(props?.contactValues?.id)
                }}
              />
            </Col>
          </Row>
          <Row className="my-2 ms-4">
            <Col xs="auto" className="mt-3">
              <label>Name:</label>
            </Col>
            <Col>
              <Field
                name={`${contact}.contact.name`}
                component={customTextField}
              />
            </Col>
          </Row>
          <Row className="my-2 ms-4">
            <Col xs="auto" className="mt-3">
              <label>Title:</label>
            </Col>
            <Col>
              <Field
                name={`${contact}.contact.title`}
                component={customTextField}
              />
            </Col>
          </Row>
          <Row className="my-2 ms-4">
            <Col xs="auto" className="mt-3">
              <Field
                name={`${contact}.contact.is_pm_displayed`}
                component={CheckboxField}
                label="Private Message"
              />
            </Col>
          </Row>
          <Row className="my-2 ms-4">
            <Col xs="auto" className="mt-3">
              <Field
                name={`${contact}.contact.is_email_displayed`}
                component={CheckboxField}
                label="Email"
              />
            </Col>
            <Col>
              <Field
                name={`${contact}.contact.email`}
                component={customTextField}
              />
            </Col>
          </Row>
          <Row className="my-2 ms-4">
            <Col xs="auto" className="mt-3">
              <Field
                name={`${contact}.contact.is_phone_displayed`}
                component={CheckboxField}
                label="Phone"
              />
            </Col>
            <Col>
              <Field
                name={`${contact}.contact.phone`}
                component={customTextField}
                normalize={value => {
                  if (value) {
                    const phoneNumber = value?.replace(/[A-Za-z]+/g, "")
                    return phoneNumber
                  }
                  return value
                }}
              />
            </Col>
          </Row>
          <Row className="mt-3 d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Save"
                disabled={disableSaveButton(
                  props?.contactValues?.name,
                  props?.contactValues?.email,
                  props?.contactValues?.is_email_displayed,
                  props?.contactValues?.phone,
                  props?.contactValues?.is_phone_displayed
                )}
                onClick={() => {
                  updateContactHandler(props?.contactValues)
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>
    )
  }
)

export default ContactCard
